import React from 'reactn';
import { Box } from '@material-ui/core';
import styled from 'styled-components';

import theme from 'meta/theme';
import CustomLink from './CustomLink';

const FooterContainer = styled.footer`
	background: ${theme.palette.primary.main};
	width: 100%;
	padding: 0px 20%;
	display: flex;
	justify-content: space-between;

	${theme.breakpoints.down('xs')} {
		padding: 0px ${theme.spacing(2)}px;
	}
`;

const Footer: React.FC = () => (
	<FooterContainer>
		<Box p={3}>
			<CustomLink to="https://www.patreon.com/oldschoolgg">Patreon</CustomLink>
			<br />
			<CustomLink to="https://support.oldschool.gg/">Discord Server</CustomLink>
			<br />
			<CustomLink to="https://invite.oldschool.gg/">Bot Invite</CustomLink>
			<br />
		</Box>
		<Box textAlign="right" p={3}>
			<CustomLink to="https://www.oldschool.gg/oldschoolbot">Old School Bot</CustomLink>
			<br />
			<CustomLink to="https://www.oldschool.gg/clues">Clue Simulator</CustomLink>
			<br />
			<CustomLink to="https://github.oldschool.gg/">Github</CustomLink>
		</Box>
	</FooterContainer>
);

export default Footer;
